import {
	createStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';
// Import enumerations
import {
	BreakpointWidth
} from '@app/enumerations';

const styles = (theme: Theme) => {

	return createStyles({
		buildingCoverageLimitsBox_inputContainer: {
			display: 'flex',
			flexDirection: 'column',
		},
		buildingCoverageLimitsBox_coverageLimits: {
			'& > div:last-child': {
				padding: theme.spacing(3, 0, 2, 0)
			},
			'& > div:first-child': {
				[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
					padding: theme.spacing(2, 0, 3, 0)
				},
				[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
					padding: theme.spacing(0, 0, 3, 0)
				},
			},
			'& > div:nth-child(n+2):nth-last-child(n+2)': {
				padding: theme.spacing(3, 0),
			},
			'& > div:only-child': {
				padding: theme.spacing(2, 0)
			}
		},
	});
}

export default styles;
